import React, { FunctionComponent } from 'react';
import { Grid, Typography, makeStyles } from '@rbx/ui';
import { HttpMethods } from '@modules/openCloud/utils/oasTypes';
import ColoredMethod from '@modules/openCloud/page/main/components/ColoredMethod';

import styles from '@modules/ui/shared/utils/styles';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';

const marginLeft = -28;

const useStyles = makeStyles<{ enableNewLayout: boolean }>()((_, { enableNewLayout }) => {
  if (enableNewLayout) {
    return {
      title: {
        fontSize: '14px',
        alignSelf: 'center',
        paddingLeft: 4,
        ...styles.wordBreakWrap,
      },
      method: {
        marginTop: 1,
        '& .MuiTypography-root': {
          fontSize: 14,
        },
      },
      container: {
        justifyContent: 'space-between',
        wordBreak: 'keep-all',
        gap: '4px',
      },
    };
  }

  return {
    title: {
      flex: 1,
      paddingLeft: 4,
      ...styles.wordBreakWrap,
    },
    method: {
      marginTop: 1,
      marginRight: 6,
      flexBasis: 64,
      '& .MuiTypography-root': {
        fontSize: 14,
      },
    },
    container: {
      marginLeft,
      width: `calc(100% + ${-marginLeft}px)`,
    },
  };
});

export interface EndpointTreeItemProps {
  method: HttpMethods;
  title: string;
}

const EndpointTreeItem: FunctionComponent<React.PropsWithChildren<EndpointTreeItemProps>> = ({
  method,
  title,
}) => {
  const { enableNewLayout } = useAppConfig();
  const {
    classes: { title: titleStyle, method: methodStyle, container },
  } = useStyles({ enableNewLayout: enableNewLayout ?? false });

  return (
    <Grid container className={container} wrap='nowrap' alignItems='flex-start'>
      {!enableNewLayout && (
        <Grid container className={methodStyle} justifyContent='flex-end'>
          <ColoredMethod method={method} />
        </Grid>
      )}
      <Typography className={titleStyle} variant='body1'>
        {title}
      </Typography>
      {enableNewLayout && (
        <Grid className={methodStyle}>
          <ColoredMethod method={method} />
        </Grid>
      )}
    </Grid>
  );
};

export default EndpointTreeItem;
